
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/autosusados/[_id]",
      function () {
        return require("private-next-pages/autosusados/[_id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/autosusados/[_id]"])
      });
    }
  